import React, { useState } from "react";
import SearchBar from "../components/searchbar";
import Add from '@material-ui/icons/Add';
import {MdOutlineVideoCall} from 'react-icons/md';
import { ButtonModal, ColumnRight, ContainerSearchBar, TitleSearch } from "../components/searchbar/styles";
import { ContainerDashboard } from "../dashboard/styles";

const PublisherPlans = () => {

  const [searchedString, setSearchedString] = useState('');

  const onChangeHandler = (e) => {
    setSearchedString(e.target.value);
}

  return (
            <>
              <ContainerSearchBar>
              <TitleSearch>
              Planos
              </TitleSearch>
              <ColumnRight>
              <SearchBar customPlaceholder='Buscar plano'
                        onChangeHandler={onChangeHandler}
                        searchedString={searchedString}
                        setSearchedString={setSearchedString}/>
              <ButtonModal>
                <Add  style={{color:"#FF4C00", paddingRight:"5px"}}size={25}/>
              Adicionar
              </ButtonModal>
              </ColumnRight>
              </ContainerSearchBar>
              </>
)}
export default PublisherPlans;
